import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  h1: {
    color: '#010341',
  },
  subtitle: {
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px',
    color: '#FFFFFF',
  },
  hero: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    backgroundRepeat: 'no-repeat'
  }
});
